import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Lazy load pages for code splitting
const Home = lazy(() => import("./pages/Home"));
const Technology = lazy(() => import("./pages/Technology"));
const Machinery = lazy(() => import("./pages/Machinery"));
const Career = lazy(() => import("./pages/Career"));
const Contact = lazy(() => import("./pages/Contact"));
const Certifikaty = lazy(() => import("./pages/Certifikaty"));
const Galerie = lazy(() => import("./pages/Galerie"));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen bg-industrial-black flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-industrial-yellow border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App min-h-screen bg-industrial-black">
          <BrowserRouter>
            <Header />
            <main>
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/technology" element={<Technology />} />
                  <Route path="/machinery" element={<Machinery />} />
                  <Route path="/career" element={<Career />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/certifikaty" element={<Certifikaty />} />
                  <Route path="/galerie" element={<Galerie />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
